(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    selectors: {
      discounted: '[data-js-price-subscription]',
      subscription: '[data-js-price-subscription]',
      compare: '[data-js-compare-price]',
      savingsMsg: '[data-js-discount-savings-msg]'
    },
    cleanRegex: /[^0-9.,]/g,
    // Regex matches 1 or 2 digits followed strictly by % (e.g. 5%, 15%)
    percentageRegex: /\b\d{1,2}%/, 
    debounceTime: 50
  };

  let debounceTimer = null;

  /**
   * Recursive Helper: Safely finds and replaces text inside elements
   * without destroying HTML tags (<b>, <span>, etc.)
   */
  const replaceInTextNodes = (node, regex, replacement) => {
    if (node.nodeType === 3) { // Node.TEXT_NODE
      const currentText = node.nodeValue;
      
      // Check if this specific text node has the pattern
      if (regex.test(currentText)) {
        // Optimization: Don't write to DOM if value is same
        // We construct what the new string WOULD be
        const newText = currentText.replace(regex, replacement);
        
        if (currentText !== newText) {
          node.nodeValue = newText;
        }
      }
    } else if (node.nodeType === 1) { // Node.ELEMENT_NODE
      // If it's an element (like <b>), look inside it
      node.childNodes.forEach(child => replaceInTextNodes(child, regex, replacement));
    }
  };

  const parsePrice = (str) => {
    if (!str) return null;
    const num = parseFloat(str.replace(CONFIG.cleanRegex, '').replace(',', '.'));
    return isNaN(num) ? null : num;
  };

  /**
   * Updates savings messages while preserving HTML
   */
  const updateSavingsMessages = (percentage) => {
    const elements = document.querySelectorAll(CONFIG.selectors.savingsMsg);
    if (elements.length === 0) return;

    const newSnippet = `${percentage}%`;

    elements.forEach(el => {
      // Use the recursive walker instead of setting .textContent
      replaceInTextNodes(el, CONFIG.percentageRegex, newSnippet);
    });
  };

  /**
   * Core Logic
   */
  const calculateAndInject = () => {
    const priceEl = document.querySelector(CONFIG.selectors.discounted);
    const subEl = document.querySelector(CONFIG.selectors.subscription);
    const compareEl = document.querySelector(CONFIG.selectors.compare);

    if (!compareEl) return;

    // Get Prices
    let currentPrice = priceEl ? parsePrice(priceEl.textContent) : null;
    if (!currentPrice && subEl) {
      currentPrice = parsePrice(subEl.textContent);
    }
    const oldPrice = parsePrice(compareEl.textContent);

    // Calculate
    if (currentPrice !== null && oldPrice !== null && oldPrice > currentPrice) {
      const discountVal = ((oldPrice - currentPrice) / oldPrice) * 100;
      const calculatedPercentage = Math.floor(discountVal);

      if (calculatedPercentage > 0) {
        updateSavingsMessages(calculatedPercentage);
      }
    }
  };

  const scheduleUpdate = () => {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(calculateAndInject, CONFIG.debounceTime);
  };

  const init = () => {
    calculateAndInject();

    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(document.body, {
      childList: true,      
      subtree: true,        
      characterData: true   
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

// TO-DO: Auto-select between One-time vs Subscription as per the URL parameter ?type
(function() {
  const PARAM_NAME = "type";
  const ATTR_NAME = "data-js-selling-type";
  const HYDRATION_DELAY = 1000; // Waits 1s for React/Shopify to become interactive
  const POLL_INTERVAL = 500;    // Checks for the element every 500ms
  const MAX_ATTEMPTS = 20;      // Stops checking after 10 seconds

  // 1. Handle Clicks (Updates URL)
  // Uses capture phase (true) to detect clicks before other scripts intercept them
  window.addEventListener("click", (event) => {
    const target = event.target.closest(`[${ATTR_NAME}]`);
    if (!target) return;

    const val = target.getAttribute(ATTR_NAME);
    const url = new URL(window.location);

    if (url.searchParams.get(PARAM_NAME) !== val) {
      url.searchParams.set(PARAM_NAME, val);
      window.history.pushState({}, "", url);
    }
  }, true);

  // 2. Handle Page Load (Simulates Click based on URL)
  const desiredType = new URLSearchParams(window.location.search).get(PARAM_NAME);
  if (!desiredType) return;

  const selector = `[${ATTR_NAME}="${CSS.escape(desiredType)}"]`;
  let attempts = 0;

  const poller = setInterval(() => {
    const element = document.querySelector(selector);
    attempts++;

    if (element) {
      clearInterval(poller);
      // Wait for page hydration, then trigger click
      setTimeout(() => {
        element.click();
        // Dispatches a native event as a fallback for React listeners
        element.dispatchEvent(new MouseEvent("click", { 
          bubbles: true, 
          cancelable: true, 
          view: window 
        }));
      }, HYDRATION_DELAY);
    } else if (attempts >= MAX_ATTEMPTS) {
      clearInterval(poller);
    }
  }, POLL_INTERVAL);
})();